import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'formatTime'
})
export class FormatTimePipe implements PipeTransform {

  transform(value: any, args?: any): any {
    var timeString = value;
    var H = +timeString.substr(0, 2);
    var h = H % 12 || 12;
    timeString = h + timeString.substr(2, 3);
    return timeString;
  }

}
